import { useEffect, useState } from "react";
import { RawIntlProvider } from "react-intl";
import { useSelector } from "react-redux";

import { kaddimIntl } from "_metronic/i18n/intl";

export default function I18nProvider({ children }) {
  const locale = useSelector(({ i18n }) => i18n.lang);
  const [intl, setIntl] = useState(kaddimIntl.intl);

  useEffect(() => {
    kaddimIntl.locale = locale;
    setIntl(kaddimIntl.intl);
  }, [locale]);

  if (!intl) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center mt-5">
        <div className="kt-spinner kt-spinner--v2 kt-spinner--lg kt-spinner--brand" />
      </div>
    );
  }

  return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
}
